import {postData} from "./httpRequest";         // 参与活动记录组件


export function warrantLogin(callback) {
       var user_id = getUrlKey('user_id');
    if(localStorage.getItem('user-token') && !user_id){
        callback({'message': '授权成功', 'status': 0});
    }else{
        var time = getUrlKey('time');
        var sign = getUrlKey('sign');
        var member_id = getUrlKey('member_id');
        var param = {
            'user_id': user_id,
            'time': time,
            'sign': sign,
            'member_id': member_id,
        };
        postData('/wap/index/warrant', param).then(res => {
            if (res.data.status == 0) {
                if(res.data.data.token) {
                    localStorage.setItem('user-token', res.data.data.token)
                }
                if (res.data.data.type == '0') {
                    var ua = window.navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                        // window.open(res.data.data.url);
                    }
                }
                callback({'message': '授权成功', 'status': 0});
            } else {
                callback({'message': res.data.message, 'status': 1});
            }
        });
    }
}


/**
 * getUrlKey 截取地址栏参数
 * @param value
 * @returns {String}
 */
function getUrlKey(name) {
    return (
        decodeURIComponent(
            (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
                location.href
            ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
    );
}



// WEBPACK FOOTER //
// ./src/wap/assets/js/login.js